// Error Page
import state from './state.js';

export default function showError() {
  // Show error UI
}
